import React from 'react';
import { pdf, Font, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import HelveticaBold from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-75Bd.ttf'; 
import HelveticaRd from '../../../../assets/Fonts/HelveticaNeueLTGEOW82-55Rm.ttf'; 
import FontLetter from '../../../../assets/Fonts/blfont.ttf';  
import BLicon from "../../../../assets/Icon/BLicon";


const formatDate = (dateString) => {

    const purchasedAtDate = new Date(dateString);

    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
     
    const day = purchasedAtDate.getDate();
    const month = months[purchasedAtDate.getMonth()];
    const year = purchasedAtDate.getFullYear();

    return `${day} ${month} ${year}`;
};
 

 

Font.register({
    family: 'HelveticaRd',  
    src: HelveticaRd, 
});

Font.register({
    family: 'HelveticaBold', 
    src: HelveticaBold, 
});
 

Font.register({
    family: 'FontLetter', 
    src: FontLetter, 
});
 
 


const styles = StyleSheet.create({

    page: {
        fontFamily: 'HelveticaRd', 
        backgroundColor: '#FFF',
        padding: '10px 10px',
        fontSize: '8px',
        lineHeight: 1.2, 
        textAlign: 'justify',
    },  
    b: { 
        fontFamily: 'HelveticaBold', 
    }, 
    FontLetter: { 
        fontFamily: 'FontLetter'
    }, 

});

 


const MyDocument = ({ container }) => (
    <Document>

        <Page size="A4" style={styles.page}>
   
 
                    <View style={{  flexDirection: "row", }}> 
                        <View style={{ width: '50%'    }}> 

                            <View style={{ display: "table", flexDirection: "column", }}> 
                                <View style={{ width: '100%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0}}> 
                                    <Text>SHIPPER</Text> 
                                </View>
                                <View style={{ width: '100%', height: '60px', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px" , borderBottom: 0}}> 
                                    
                                    <Text>{container.shipper ? container.shipper.name : '- - -'}</Text>
                                    <Text>{container.shipper ? container.shipper.address : '- - -'}</Text> 
                                    <Text>{container.shipper ? container.shipper.address_2 : ''}</Text> 
                                    <Text>{container.shipper ? container.shipper.district : ''}</Text> 
                                    <Text>{container.shipper ? container.shipper.code : ''}</Text> 
                                    <Text>{container.shipper ? container.shipper.country +',' : ''} {container.shipper ? container.shipper.city : ''}</Text> 
                            
                                 </View>
                            </View>

                         </View> 
                        <View style={{ width: '50%' }}> 


                            <View style={{ display: "table", flexDirection: "row", }}> 

                                <View style={{ width: '60%', flexDirection: 'column', border: "0px solid #7c7c7c" }}> 
                                    <View style={{ width: '100%', flexDirection: 'column',  marginTop: '25px', }}> 
                                        <Text style={{ ...styles.b, fontSize: '13px', textAlign: 'center' }}>COPY NON NEGOTIABLE </Text>  
                                        <Text style={{ ...styles.b, fontSize: '13px', textAlign: 'center' }}>BILL OF LADING </Text>  
                                    </View>
                                    
                                </View>

                                <View style={{ width: '40%', flexDirection: 'column', border: "0px solid #7c7c7c" }}> 
                                         
                                    <View style={{ display: "table", flexDirection: "column" , marginTop: '5px',}}> 
                                        <View style={{ width: '100%', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, fontSize: '8px'}}> 
                                            <Text>VOYAGE NUMBER</Text> 
                                        </View>
                                        <View style={{ width: '100%', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', borderBottom: 0, fontSize: '8px'}}> 
                                            <Text>{ container.voyage_number}</Text> 
                                        </View> 
                                        <View style={{ width: '100%', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, fontSize: '8px'}}> 
                                            <Text>BILL OF LADING NUMBER </Text> 
                                        </View>
                                        <View style={{ width: '100%', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', fontSize: '8px' }}> 
                                            <Text>{ container.bl_number}</Text> 
                                        </View> 
                                    </View>
 
                                </View>
                            </View>

                        </View>                        
                    </View>
  

                    <View style={{  flexDirection: "row", }}> 
 
                        <View style={{ width: '50%' }}> 


                            <View style={{ display: "table", flexDirection: "column", }}> 
                                <View style={{ width: '100%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0}}> 
                                    <Text>CONSIGNEE</Text> 
                                </View>
                                <View style={{ width: '100%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px" , borderBottom: 0}}> 
                                    <Text>AUTO IMPORT GEORGIA</Text> 
                                    <Text>VARKETILI 3 4 M/D, BLDG 413, FL 96,</Text> 
                                    <Text>ISANI-SAMGORI 0163 TBILISI GEORGIA</Text> 
                                    <Text>VAT: 406203120</Text> 
                                    <Text>TEL: +995 591 29 60 60</Text> 
                                    <Text>INFO@AUTOIMPORT.COM.GE</Text> 
                                 </View>
                            </View>

                            <View style={{ display: "table", flexDirection: "column", }}> 
                                <View style={{ width: '100%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0}}> 
                                    <Text>NOTIFY PARTY, Carrier not to be responsible for failure to notify</Text> 
                                </View>
                                <View style={{ width: '100%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px" , borderBottom: 0}}> 
                                    <Text>AUTO IMPORT GEORGIA</Text> 
                                    <Text>VARKETILI 3 4 M/D, BLDG 413, FL 96,</Text> 
                                    <Text>ISANI-SAMGORI 0163 TBILISI GEORGIA</Text> 
                                    <Text>VAT: 406203120</Text> 
                                    <Text>TEL: +995 591 29 60 60</Text> 
                                    <Text>INFO@AUTOIMPORT.COM.GE</Text> 
                                 </View>
                            </View>

                        </View>  

                        <View style={{ width: '50%',  borderRight: "1px solid #7c7c7c",}}> 

                            <View style={{ display: "table", flexDirection: "column", }}> 
                                <View style={{ width: '100%', flexDirection: 'column', borderTop: "1px solid #7c7c7c", borderBottom: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb' }}> 
                                    <Text>EXPORT REFERENCES</Text> 
                                </View>
                                <View style={{ width: '100%', flexDirection: 'column', padding: "3px", paddingTop: '25px'}}> 
                                    <Text style={{textAlign: 'center', width: '100%' }} ><Text style={{ ...styles.b,  textDecoration: 'underline',   }} >CARRIER: </Text> {container.marine_line ? container.marine_line.name : '- - -'} Société Anonyme au Capital de 234 988 330 Euros</Text> 
                                    <Text style={{textAlign: 'center', width: '100%' }} >Head Office: 4, quai d'Arenc - 13002 Marseille - France</Text> 
                                    <Text style={{textAlign: 'center', width: '100%' }} >Tel: (33) 4 88 91 90 00 - Fax: (33) 4 88 91 90 95</Text> 
                                    <Text style={{textAlign: 'center', width: '100%' }} >562 024 422 R.C.S. Marseille</Text> 
                                 </View>
                            </View>

                         </View> 

                    </View>
  

 
                    <View style={{ display: "table", flexDirection: "row", }}> 
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0}}> 
                            <Text>PRE CARRIAGE BY* </Text> 
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, borderLeft: 0 }}> 
                            <Text>PLACE OF RECEIPT*</Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, borderLeft: 0 }}> 
                            <Text>FREIGHT TO BE PAID AT</Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb',borderBottom: 0, borderLeft: 0 }}> 
                            <Text>NUMBER OF ORIGINAL BL</Text>
                        </View>
                    </View>

 
                    <View style={{ display: "table", flexDirection: "row", }}> 
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', borderBottom: 0}}> 
                            <Text></Text> 
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', borderBottom: 0, borderLeft: 0 }}> 
                            <Text></Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', borderBottom: 0, borderLeft: 0 }}> 
                            <Text>TBILISI</Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff',borderBottom: 0, borderLeft: 0 }}> 
                            <Text>THREE (3)</Text>
                        </View>
                    </View>

                    <View style={{ display: "table", flexDirection: "row", }}> 
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0}}> 
                            <Text>VESSEL </Text> 
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, borderLeft: 0 }}> 
                            <Text>PORT OF LOADING</Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, borderLeft: 0 }}> 
                            <Text>PORT OF DISCHARGE</Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb',borderBottom: 0, borderLeft: 0 }}> 
                            <Text>FINAL PLACE OF DELIVERY*</Text>
                        </View>
                    </View>

                     
 
                    <View style={{ display: "table", flexDirection: "row", }}> 
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', borderBottom: 0}}> 
                            <Text>{container.ship_name || '- - -'}</Text> 
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', borderBottom: 0, borderLeft: 0 }}> 
                            <Text style={{textTransform: 'uppercase'}}>{container.sender_country ? container.sender_country.name : '- - -'}, {container.sender_city ? container.sender_city.name : '- - -'}</Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff', borderBottom: 0, borderLeft: 0 }}> 
                            <Text style={{textTransform: 'uppercase'}}>{container.reciever_country ? container.reciever_country.name : '- - -'}, {container.reciever_city ? container.reciever_city.name : '- - -'}</Text>
                        </View>
                        <View style={{ width: '25%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#fff',borderBottom: 0, borderLeft: 0 }}> 
                            <Text></Text>
                        </View>
                    </View>


                    
                    <View style={{ display: "table", flexDirection: "row", }}> 
                        <View style={{ width: '17%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px 0px", backgroundColor: '#ebebeb', borderBottom: 0, }}> 
                            <Text style={{textAlign: 'center', width: '100%', borderBottom: "1px solid #7c7c7c" }}>MARKS AND NOS </Text> 
                            <Text style={{textAlign: 'center', width: '100%' }}>CONTAINER AND SEALS </Text> 
                        </View>
                        <View style={{ width: '11%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px 0px", backgroundColor: '#ebebeb',borderBottom: 0,  borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%', borderBottom: "1px solid #7c7c7c" }}>NO AND KIND</Text> 
                            <Text style={{textAlign: 'center', width: '100%' }}>OF PACKAGES </Text> 
                        </View>
                        <View style={{ width: '45%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%' }}>DESCRIPTION OF PACKAGES AND GOODS AS STATED BY SHIPPER</Text>
                            <Text style={{textAlign: 'center', width: '100%' }}>SHIPPER'S LOAD STOW AND COUNT SAID TO CONTAIN</Text>
                        </View>
                        <View style={{ width: '12%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0,borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%' }}>GROSS WEIGHT</Text>
                            <Text style={{textAlign: 'center', width: '100%' }}>CARGO</Text>
                        </View>
                        <View style={{ width: '5%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%' }}>TARE</Text> 
                        </View>
                        <View style={{ width: '10%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderBottom: 0, borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%' }}>MEASUREMENT</Text> 
                        </View>
                    </View>

                    
                    <View style={{ display: "table", flexDirection: "row", }}> 
                        <View style={{ width: '17%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px 0px",}}> 
                            <Text style={{textAlign: 'center', width: '100%', borderBottom: "1px solid #7c7c7c" }}>{ container.container_number } </Text> 
                            <Text style={{textAlign: 'center', width: '100%' }}>{ container.seal_number }  </Text> 
                        </View>
                        <View style={{ width: '11%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px 0px",  borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%', marginTop: "5px" }} >1 x 40HC</Text> 
                        </View>
                        <View style={{ width: '45%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px",  borderLeft: 0 }}> 
                             {container.cargos && container.cargos.length > 0 ? (
                                <Text style={{  width: '100%' }}>{container.cargos.length} PACKAGE(S)</Text> 
                            ) : (
                                <Text style={{  width: '100%' }}>NO PACKAGE(S)</Text> 
                            )}
                            <Text style={{  width: '100%' }}>USED CARS</Text> 
                        </View>
                        <View style={{ width: '12%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px",  borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%' }}>KGS</Text>
                            <Text style={{textAlign: 'center', width: '100%' }}>{ container.gross_weight }</Text>
                        </View>
                        <View style={{ width: '5%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px", borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%' }}>KGS</Text> 
                            <Text style={{textAlign: 'center', width: '100%' }}>3700</Text> 
                        </View>
                        <View style={{ width: '10%', flexDirection: 'column', border: "1px solid #7c7c7c", padding: "3px",  borderLeft: 0 }}> 
                            <Text style={{textAlign: 'center', width: '100%' }}>CBM</Text> 
                            <Text style={{textAlign: 'center', width: '100%' }}>41.866</Text> 
                        </View>
                    </View>

                    
          
                    
                    {container.cargos && container.cargos.length > 0 ? (
 
                        <>
                            {container.cargos && container.cargos.map((cargo, index) => (

                                <View style={{ display: "table", flexDirection: "row", }}> 

                                    <View style={{ width: '28%', flexDirection: 'column', borderLeft: "1px solid #7c7c7c", borderRight: "1px solid #7c7c7c", padding: "3px 0px",  }}> 
                                        <Text style={{textAlign: 'center', width: '100%', marginTop: "5px" }} > </Text> 
                                    </View>

                                    <View style={{ width: '45%', flexDirection: 'column', padding: "5px", paddingBottom: "0px",   borderRight: "1px solid #7c7c7c", }}> 
                                        
                                            <View style={{ display: "table", flexDirection: "row", }}> 
                                                <Text style={styles.FontLetter}>{cargo.car_info || '- - -'}</Text> 
                                                <Text style={{ width: 15, color: '#7c7c7c',  textAlign: 'center', marginTop: "-2px" }}>•</Text>
                                                <Text style={styles.FontLetter}>VIN. {cargo.vin || '- - -'}</Text> 
                                            </View>
                                            <View style={{ display: "table", flexDirection: "row",   }}> 
                                                <Text style={styles.FontLetter}>{cargo.name || '- - -'}</Text> 
                                                <Text style={{ width: 15, color: '#7c7c7c',  textAlign: 'center', marginTop: "-2px" }}>•</Text>
                                                <Text style={styles.FontLetter}>{cargo.mobile || '- - -'}</Text> 
                                                <Text style={{ width: 15, color: '#7c7c7c',  textAlign: 'center', marginTop: "-2px" }}>•</Text>
                                                <Text style={styles.FontLetter}>{cargo.personal || '- - -'}</Text>  
                                            </View> 

                                    </View>
                                    <View style={{ width: '27%', flexDirection: 'column',   borderRight: "1px solid #7c7c7c", padding: "3px 0px" }}> 
                                        <Text style={{textAlign: 'center', width: '100%' }}> </Text>
                                    </View>
                                </View>
                            ))}
                            
                        </>
                       
                    ) : ('' )}
         
     
                     
                    

       
                    <View style={{ display: "table", flexDirection: "row",  border: "1px solid #7c7c7c", }}> 
                       
                        <View style={{ width: '25%', flexDirection: 'column',   padding: "3px 0px",  }}> 
                            <Text style={{textAlign: 'center', width: '100%', marginTop: "3px" }} > </Text> 
                        </View>

                        <View style={{ width: '75%', flexDirection: 'column', padding: "3px", paddingBottom: 0 }}> 
                            
                            <View style={{ display: "table", flexDirection: "column", }}>  
                                <Text style={styles.FontLetter}>Shipped on Board CNC PLUTO { formatDate(container.send_at) || '- - -'} {container.marine_line ? container.marine_line.name : '- - -'} Korea Co., Ltd. </Text>  
                                <Text style={styles.FontLetter}>As agents for the Carrier</Text>  
                                <Text style={{marginTop: "0px"}}>ABOVE PARTICULARS DECLARED BY SHIPPER. CARRIER NOT RESPONSIBLE.</Text>  

                            </View> 

                        </View>
                       
                    </View>
       
                   
                     
       
                    <View style={{ display: "table", flexDirection: "row",  border: "1px solid #7c7c7c", padding: "3px", backgroundColor: '#ebebeb', borderTop: 0,}}> 
                        <Text style={{ width: "100%", textAlign: "center", }}> ADDITIONAL CLAUSES</Text>  
                    </View>
       

                    <View style={{ display: "table", flexDirection: "row",  border: "1px solid #7c7c7c",   borderTop: 0,}}> 
    
                        <View style={{ width: '50%', borderRight: "1px solid #7c7c7c", padding: "3px", width: "50%", lineHeight: 1, fontSize: '6px', }}> 
                            <Text>4. Cargo at port is at merchant risk, expenses and responsibility</Text>  
                            <Text>5. FCL</Text>  
                            <Text>73. Free out</Text>  
                            <Text>77. THC at destination payable by Merchant as per line/port tariff</Text>  
                            <Text>133. Carrier haulage / door delivery: 24 hrs free period. Thereafter a detention of US$ 200 / day or fraction / truck is charged to receiver.</Text>  
                            <Text>136. The Line is not responsible for any damage or loss to the cargo or extra costs resulting from Customs inspections/sampling and/or Government regulations. Merchant, Shipper, Consignee and holder of this bill of lading will each be fully responsible for any costs, fines or penalties incurred as a result of such inspections/sampling and/or Customs actions and/or Government regulations.</Text>  
                            <Text>194. For the purpose of the present carriage, clause 14(2) shall exclude the application of the York/Antwerp rules, 2004.</Text>  
                            <Text>202. Demurrage and detention shall be calculated and paid as per general tariff available on the web site  www.cma-cgm.com, or in any of CMA CGM agency. However if special free time conditions are granted, then rates applicable as per general tariff grid shall start from the day following the last free day.</Text>  
                            <Text>216. Mis-declaration of cargo weight endangers crew, port workers and vessels' safety. Your cargo may be weighed at any place and time of carriage and any mis-declaration will expose you to claims for all losses, expenses or damages whatsoever resulting thereof and be subject to freight surcharge.</Text>  

                            <Text>225. The shipper acknowledges that the Carrier may carry the goods identified in this bill of lading on the deck of any vessel and in taking remittance of this bill of lading the Merchant (including the shipper, the consignee and the holder of the bill of lading, as the case may be) confirms his express acceptance of all the terms and conditions of this bill of lading and expressly confirms his unconditional and irrevocable consent to the possible carriage of the goods on the deck of any vessel.</Text> 
                            <Text>274. The Merchant is responsible for returning any empty container, with interior clean, free of any dangerous goods placards, labels or markings, at the designated place, and within 60 days following to the date of release, failing which the container shall be construed as lost. The Merchant shall be liable to indemnify the Carrier for any loss or expense whatsoever arising out of the foregoing, including but not limited to liquidated</Text>  

                        </View>

                        <View style={{ width: '50%', borderTop: 0, padding: "3px", fontSize: '6px', lineHeight: 1 }}> 
                            <Text>damages equivalent to the sound market value - or the depreciated value due by the Carrier to a container lessor. The Carrier is entitled to collect a deposit from the Merchant at the time of release of the container which shall be remitted as security for payment of any sums due to the Carrier, in particular for payment of all detention and demurrage and/or container indemnity as referred above.</Text>  
                            
                            <Text>366. The Merchant warrants that the particulars relating to the Goods have been checked and that such particulars are adequate and correct. In case of failure of the Merchant to comply with such warranty, the Carrier shall be entitled to charge the Merchant at any time an amount of USD 2,000 per Container or Goods (for non-containerized cargo) as processing and administrative fees. This fee shall also be applicable in case of discrepancy between the Verified Gross Mass (VGM) sent to the Carrier, or the weight declared to the Carrier (for non-containerized cargo), and the weight declared by the Shipper in his shipping instruction or otherwise weighted during the Carriage.</Text>  
                            <Text>366. The Merchant warrants that the particulars relating to the Goods have been checked and that such particulars are adequate and correct. In case of failure of the Merchant to comply with such warranty, the Carrier shall be entitled to charge the Merchant at any time an amount of USD 2,000 per Container or Goods (for non-containerized cargo) as processing and administrative fees. This fee shall also be applicable in case of discrepancy between the Verified Gross Mass (VGM) sent to the Carrier, or the weight declared to the Carrier (for non-containerized cargo), and the weight declared by the Shipper in his shipping instruction or otherwise weighted during the Carriage.</Text>  
                            <Text>372. Merchant consents to the Carrier sharing information and data contained in the Bill of Lading and/or related to the performance of the Carriage of the Goods with third parties, including but not limited to digital supply chain platforms. </Text>  
                            <Text>374.Merchant undertakes and warrants that, in no circumstance whatsoever, the Goods and the Container(s) listed in this Bill of Lading shall be destined and on-carried to Russian Federation territory or Republic of Belarus after unloading at port of discharge </Text>  
                            <Text>375.Merchant undertakes and warrants that, in no circumstance whatsoever, the Goods listed in this Bill of Lading shall be stuffed and on-carried from the Russian Federation territory or Republic of Belarus before loading at port of loading.</Text>  
                        </View>

                    </View>

                    <View style={{ display: "table", flexDirection: "row",  border: "1px solid #7c7c7c",   borderTop: 0, borderRight: 0,}}> 
                        <View style={{ width: '100%', borderRight: "1px solid #7c7c7c", padding: "3px",   lineHeight: 1, fontSize: '6px', }}> 
                            <Text>RECEIVED by the carrier from the shipper in apparent good order and condition (unless otherwise noted herein) the total number or quantity of Containers or other packages or units indicated above stated by the shipper to comprise the cargo specified above for transportation subject to all the terms hereof (including the terms on page one) from the place of receipt or the port of loading, whichever is applicable, to the port of discharge or the place of delivery, whichever is applicable. Delivery of the Goods will only be made on payment of all Freight and charges. On presentation of this document (duly endorsed) to the Carrier, by or on behalf of the holder, the rights and liabilities arising in accordance with the terms hereof shall (without prejudice to any rule of common law or statutes rendering them binding upon the shipper, holder and carrier) become binding in all respects between the Carrier and Holder as though the contract contained herein or evidenced hereby had been made between them.</Text>  
                            <Text>All claims and actions arising between the Carrier and the Merchant in relation with the contract of Carriage evidenced by this Bill of Lading shall exclusively be brought before the Tribunal de Commerce de Marseille and no other Court shall have jurisdiction with regards to any such claim or action. Notwithstanding the above, the Carrier is also entitled to bring the claim or action before the Court of the place where the defendant has his registered office.</Text>  
                            <Text>In witness whereof three (3) original Bills of Lading, unless otherwise stated above, have been issued, one of which being accomplished, the others to be void.</Text>  
                            <Text style={{...styles.b, width: '100%', textAlign: 'center'}}> (OTHER TERMS AND CONDITIONS OF THE CONTRACT ON PAGE ONE)</Text>  
                        </View>
                    </View>

                    <View style={{ display: "table", flexDirection: "row",  border: "1px solid #7c7c7c",  borderTop: 0, }}> 

                        <View style={{ width: '50%', borderRight: "1px solid #7c7c7c"  }}>

                            <View style={{  flexDirection: "row",   }}> 
                                <Text style={{width: '50%', backgroundColor: '#ebebeb',  borderRight: "1px solid #7c7c7c", padding: "3px"}}>PLACE AND DATE OF ISSUE</Text>
                                <Text style={{width: '50%',   padding: "3px"}}>SEOUL { formatDate(container.entry_at) || '- - -'}</Text>
                            </View>

                            <Text style={{ borderBottom: "1px solid #7c7c7c", padding: "3px", borderTop: "1px solid #7c7c7c",}} >SIGNED FOR THE SHIPPER</Text>
                            <Text style={{ padding: "3px" }} >*APPLICABLE ONLY WHEN THIS DOCUMENT IS USED AS A COMBINED TRANSPORT BILL OF LADING</Text>

                          </View>
                          <View style={{ width: '50%', backgroundColor: '#ebebeb',   padding: "3px"}}> 
                            <Text>SIGNED FOR THE CARRIER {container.marine_line ? container.marine_line.name : '- - -'} S.A.</Text>
                            <Text>BY {container.marine_line ? container.marine_line.name : '- - -'} Korea Co., Ltd.</Text>
                            <Text>as agents for the carrier {container.marine_line ? container.marine_line.name : '- - -'} S. A.</Text>
                            <Text style={{ marginTop: "10px" }}>______________________________________</Text>
                          </View>
                    </View>
 
        </Page>
 
    </Document>
);



const cl = {
    btnContainerTop: {
      border: '1px solid',
      backgroundColor: '#fff',
      borderRadius: '5px',
      display: 'flex',
      cursor: 'pointer',
      alignItems: 'center',
      fontFeatureSettings: '"case" on',
      lineHeight: 1.25,
      fontWeight: 500,
      padding: '0px 7px 0px 0px',
      fontSize: '13px',
      overflow: 'hidden',
      color: 'var(--secondary-text-color)',
      borderColor: 'var(--border-color)',
    },
    icon: {
      maxWidth: '28px',
      maxHeight: '28px',
      minWidth: '28px',
      minHeight: '28px',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '7px',
      display: 'flex',
      color: 'var(--secondary-text-color)',
      backgroundColor: 'var(--secondary-background)',
    },
    iconsvg: {
      maxWidth: '18px',
      maxHeight: '18px',
      minWidth: '18px',
      minHeight: '18px',
    },
  };

const Bl = ({ containerService, defaultContainer }) => {
  
    const generatePDF = async () => {
        const blob = await pdf(<MyDocument container={defaultContainer} />).toBlob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.target = 'blank';
        // link.download = 'invoice.pdf';
        link.click();
    };

    return (
        <>
            <span style={cl.btnContainerTop} onClick={generatePDF}>
                <span style={cl.icon}><BLicon style={cl.iconsvg} /></span> Bill of Lading
            </span>
        </>
    );
};

export default Bl;
